import React, { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoClose, IoCar } from "react-icons/io5";
import {
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaCarSide,
  FaMoneyBillWave,
  FaUser,
} from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { cars, coupons, rentals, locations, additionalOptions } from "../../services/api";
import moment from "moment";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import OpelCorsa from "../../assets/images/opelcorsa.jpg";
import SpaceStar from "../../assets/images/MITS-SPACE.png";
import Peugeot208 from "../../assets/images/p-208.jpg";
import Peugeot108 from "../../assets/images/108-p.webp";
import CitroenC1 from "../../assets/images/C1.jpeg";
import Micra from "../../assets/images/PHOTO-2022-01-23-14-12-06.jpg";
import Panda from "../../assets/images/PHOTO-2022-01-23-14-12-05-1.jpg";
import Stonic from "../../assets/images/KIA-STONIC-Manual-1.png";
import i20 from "../../assets/images/HYUNDAI-i20-Manual-1.png";
import quashqai from "../../assets/images/quashqai.jpg";
import duster from "../../assets/images/duster.jpeg";
import crossland from "../../assets/images/opel-crossland.webp";
import clio from "../../assets/images/RENAULT-CLIO-Manual-1.png";
import rio from "../../assets/images/KIA-RIO-Auto-1.png";
import Wrangler5D from "../../assets/images/jeep-wr-5d.png";
import WranglerCabrio from "../../assets/images/Jeep-wrangler-cabrio.png";
import Discovery from "../../assets/images/land-rover.webp";
import Wrangler from "../../assets/images/JEEP-WRANGLER-Auto-1.png";
import WranglerSahara from "../../assets/images/JEEP-WRANGLER-1.png.webp";
import Berlingo from "../../assets/images/CITROEN-BERLINGO-Auto.png.webp";
import Doblo from "../../assets/images/FIAT-DOBLO-Manual-1.png.webp";
import TRoc from "../../assets/images/vw-t-roc.png";
import C1Cabrio from "../../assets/images/PHOTO-2022-01-23-14-12-11.jpg.webp";
import MiniCooper from "../../assets/images/MINI-COOPER-Cabrio-Auto-1.png.webp";
import Fiat500 from "../../assets/images/FIAT-500-Auto-Cabrio-1.png.webp";
import SmartForTwo from "../../assets/images/SMART-ForTwo-Cabrio-Manual-4.png.webp";
import SmartForTwoAuto from "../../assets/images/SMART-ForTwo-Cabrio-Auto-2.png.webp";
import Buggy800 from "../../assets/images/CF-MOTO-BUGGY-800cc-1.png.webp";
import Buggy550 from "../../assets/images/CF-MOTO-BUGGY-550cc-1.png.webp";
import ATV450 from "../../assets/images/5_14f72470629695dca3487f902b2c012f.png.webp";
import RangeSport from "../../assets/images/PHOTO-2022-01-22-12-09-42.jpg";
import C3Aircross from "../../assets/images/PHOTO-2022-01-25-15-13-22.jpg";
import C3 from "../../assets/images/PHOTO-2022-01-22-11-45-44-1.jpg";
import C4Cactus from "../../assets/images/PHOTO-2022-01-22-11-51-47.jpg";
import MiniCountryman from "../../assets/images/PHOTO-2022-01-25-15-13-22-1.jpg";
import Glb2022 from "../../assets/images/MERCEDES-BENZ-GLB-2022-Automatic-1.png";
import Gla2023 from "../../assets/images/253_9060274dbdc76eb56b4a456a70298fff.png";
import BmwX1 from "../../assets/images/BMW-X1-2023-Automatic.png";
import BmwX2 from "../../assets/images/BMW-X2-Automatic-1.png";
import Sportage from "../../assets/images/KIA-SPORTAGE-Auto-1.png";
import Picanto from "../../assets/images/picanto.jpg";
import Cayenne from "../../assets/images/PORSCHE-CAYENNE-Auto-1.png";
import Bike125 from "../../assets/images/125bike.png";
import logo from "../../assets/images/logo-1.png";

const imageMap = {
  "opelcorsa.jpg": OpelCorsa,
  "MITS-SPACE.png": SpaceStar,
  "p-208.jpg": Peugeot208,
  "108-p.webp": Peugeot108,
  "C1.jpeg": CitroenC1,
  "PHOTO-2022-01-23-14-12-06.jpg": Micra,
  "PHOTO-2022-01-23-14-12-05-1.jpg": Panda,
  "KIA-STONIC-Manual-1.png": Stonic,
  "HYUNDAI-i20-Manual-1.png": i20,
  "quashqai.jpg": quashqai,
  "duster.jpeg": duster,
  "opel-crossland.webp": crossland,
  "RENAULT-CLIO-Manual-1.png": clio,
  "KIA-RIO-Auto-1.png": rio,
  "jeep-wr-5d.png": Wrangler5D,
  "Jeep-wrangler-cabrio.png": WranglerCabrio,
  "land-rover.webp": Discovery,
  "JEEP-WRANGLER-Auto-1.png": Wrangler,
  "JEEP-WRANGLER-1.png.webp": WranglerSahara,
  "CITROEN-BERLINGO-Auto.png.webp": Berlingo,
  "FIAT-DOBLO-Manual-1.png.webp": Doblo,
  "vw-t-roc.png": TRoc,
  "PHOTO-2022-01-23-14-12-11.jpg.webp": C1Cabrio,
  "MINI-COOPER-Cabrio-Auto-1.png.webp": MiniCooper,
  "FIAT-500-Auto-Cabrio-1.png.webp": Fiat500,
  "SMART-ForTwo-Cabrio-Manual-4.png.webp": SmartForTwo,
  "SMART-ForTwo-Cabrio-Auto-2.png.webp": SmartForTwoAuto,
  "CF-MOTO-BUGGY-800cc-1.png.webp": Buggy800,
  "beach_buggy.png": Buggy550,
  "5_14f72470629695dca3487f902b2c012f.png.webp": ATV450,
  "PHOTO-2022-01-22-12-09-42.jpg": RangeSport,
  "PHOTO-2022-01-25-15-13-22.jpg": C3Aircross,
  "PHOTO-2022-01-22-11-45-44-1.jpg": C3,
  "PHOTO-2022-01-22-11-51-47.jpg": C4Cactus,
  "PHOTO-2022-01-25-15-13-22-1.jpg": MiniCountryman,
  "MERCEDES-BENZ-GLB-2022-Automatic-1.png": Glb2022,
  "253_9060274dbdc76eb56b4a456a70298fff.png": Gla2023,
  "BMW-X1-2023-Automatic.png": BmwX1,
  "BMW-X2-Automatic-1.png": BmwX2,
  "KIA-SPORTAGE-Auto-1.png": Sportage,
  "PORSCHE-CAYENNE-Auto-1.png": Cayenne,
  "125bike.png": Bike125,
  "picanto.jpg": Picanto,
};

// Get the correct image from either the imported assets or the car object
const getImage = (imagePath) => {
  if (!imagePath) return null;

  if (typeof imagePath === "string") {
    // For database images with /images/ path
    if (imagePath.startsWith("/images/")) {
      const filename = imagePath.split("/").pop();
      return imageMap[filename] || imagePath;
    }
    // For existing static imports
    const filename = imagePath.split("/").pop();
    return imageMap[filename] || imagePath;
  }

  return imagePath;
};

const CreatePartnerRentalModal = ({ isOpen, onClose, partner, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [availableCars, setAvailableCars] = useState([]);
  const [selectedCar, setSelectedCar] = useState(null);
  const [selectedCarDetails, setSelectedCarDetails] = useState(null);
  const [datePickerOpen, setDatePickerOpen] = useState({
    pickup: false,
    dropoff: false,
  });
  const [dateTimeComplete, setDateTimeComplete] = useState({
    pickup: false,
    dropoff: false,
  });
  const [timeWarnings, setTimeWarnings] = useState({
    pickup: false,
    dropoff: false,
  });
  const [availabilityData, setAvailabilityData] = useState(null);
  const [couponStatus, setCouponStatus] = useState({
    isValid: false,
    discount: 0,
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");  const [durationDiscounts, setDurationDiscounts] = useState({
    shortTerm: { discount: 0 },
    mediumTerm: { discount: 5 },
    longTerm: { discount: 10 },
  });
  
  // Additional options state
  const [additionalOptionsData, setAdditionalOptionsData] = useState([]);
  const [loadingAdditionalOptions, setLoadingAdditionalOptions] = useState(false);
  
  // Default additional options for fallback
  const defaultAdditionalOptions = [
    { _id: "default-child-seat", name: "Child Seat", description: "Add a Child Seat to your Vehicle!", price: 0, isEnabled: true },
    { _id: "default-baby-chair", name: "Baby Chair", description: "Add a Baby Chair to your Vehicle!", price: 0, isEnabled: true },
    { _id: "default-gps", name: "GPS Navigation", description: "Navigation system for your journey", price: 0, isEnabled: true }
  ];

  const [formData, setFormData] = useState({
    pickupDate: null,
    dropoffDate: null,
    pickupLocation: "",
    dropoffLocation: "",
    customPickupLocation: "",
    customDropoffLocation: "",
    firstName: "",
    lastName: "",    email: "",
    phone: "",
    age: "26+",
    additionalOptions: {},
    couponCode: "",
    notes: "",
    customPricePerDay: "", // Initialize custom price field    advancePayment: "", // NEW: Advanced payment amount
  });

  const [sameLocation, setSameLocation] = useState(true);
  
  // Default location options as fallback
  const defaultLocationOptions = [
    { value: "airport", label: "Airport of Mykonos (JMK)" },
    { value: "central", label: "Mykonos Central Office" },
    { value: "new-port", label: "Mykonos New Port (Tourlos)" },
    { value: "old-port", label: "Mykonos Old Port" },
    { value: "hotel", label: "Hotel / Apartment / Villa" },
    { value: "other", label: "Other Location (Hotel/Restaurant/Beach)" },
  ];
  
  // State for location options from API
  const [locationOptions, setLocationOptions] = useState(defaultLocationOptions);
  
  // Fetch locations when component mounts
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await locations.getActive();
        
        if (response && Array.isArray(response)) {
          // Map API locations to the format expected by the component
          const apiLocations = response.map(location => ({
            value: location._id,
            label: location.name
          }));
          
          // Always add "other" option
          apiLocations.push(
            { value: "other", label: "Other Location (Hotel/Restaurant/Beach)" }
          );
          
          setLocationOptions(apiLocations);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        // Keep using the default locations if API fails
      }
    };
    
    fetchLocations();
  }, []);
  useEffect(() => {
    if (isOpen) {
      fetchCars();
      fetchDurationDiscounts();
      fetchAdditionalOptions();
    } else {
      resetForm();
    }
  }, [isOpen]);

  // Function to fetch additional options
  const fetchAdditionalOptions = async () => {
    setLoadingAdditionalOptions(true);
    try {
      const responseOptions = await additionalOptions.getActive();
      
      if (responseOptions && Array.isArray(responseOptions) && responseOptions.length > 0) {
        setAdditionalOptionsData(responseOptions);
        const initializedOptions = {};
        responseOptions.forEach(option => {
          if (option && option._id) { // Guard against undefined option or _id
            initializedOptions[option._id] = false;
          }
        });
        setFormData(prev => ({
          ...prev,
          additionalOptions: initializedOptions
        }));
      } else {
        // Fallback to default options if API returns empty or invalid data
        // console.warn("Fetched additional options were empty or invalid; using defaults."); // Optional for debugging
        setAdditionalOptionsData(defaultAdditionalOptions);
        const initializedOptions = {};
        defaultAdditionalOptions.forEach(option => {
          if (option && option._id) { // Guard
            initializedOptions[option._id] = false;
          }
        });
        setFormData(prev => ({
          ...prev,
          additionalOptions: initializedOptions
        }));
      }
    } catch (error) {
      console.error("Error fetching additional options:", error);
      // Fallback to default options on API error
      setAdditionalOptionsData(defaultAdditionalOptions);
      const initializedOptions = {};
      defaultAdditionalOptions.forEach(option => {
        if (option && option._id) { // Guard
          initializedOptions[option._id] = false;
        }
      });
      setFormData(prev => ({
        ...prev,
        additionalOptions: initializedOptions
      }));
    } finally {
      setLoadingAdditionalOptions(false);
    }
  };

  const fetchDurationDiscounts = async () => {
    try {
      const response = await rentals.getDurationDiscounts();
      setDurationDiscounts(response.data);
    } catch (error) {
      console.error("Error fetching duration discounts:", error);
      // Consider setting default duration discounts if API fails, e.g.:
      // setDurationDiscounts({ shortTerm: { discount: 0 }, mediumTerm: { discount: 5 }, longTerm: { discount: 10 } });
    }
  };

  const resetForm = () => {
    // Determine which options data to use for initializing additionalOptions
    // Use additionalOptionsData if available and populated, otherwise fallback to defaultAdditionalOptions
    const currentOptionsSource = (additionalOptionsData && additionalOptionsData.length > 0) 
      ? additionalOptionsData 
      : defaultAdditionalOptions;
      
    const initialAdditionalOptions = {};
    currentOptionsSource.forEach(option => {
      if (option && option._id) { // Ensure option and option._id are valid
        initialAdditionalOptions[option._id] = false;
      }
    });

    setFormData({
      pickupDate: null,
      dropoffDate: null,
      pickupLocation: "",
      dropoffLocation: "",
      customPickupLocation: "",
      customDropoffLocation: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      age: "26+",
      additionalOptions: initialAdditionalOptions, // Dynamically initialized
      couponCode: "",
      notes: "",
      customPricePerDay: "",
      advancePayment: "",
    });
    setSameLocation(true);
    setSelectedCar(null);
    setSelectedCarDetails(null);
    setAvailabilityData(null);
    setCouponStatus({ isValid: false, discount: 0, message: "" });
    setErrors({});
    setTotalPrice(0);
    setDatePickerOpen({ pickup: false, dropoff: false });
    setDateTimeComplete({ pickup: false, dropoff: false });
    setTimeWarnings({ pickup: false, dropoff: false });
  };

  const fetchCars = async () => {
    try {
      setInitialLoading(true);
      const response = await cars.getAll();
      setAvailableCars(
        response.data.filter((car) => car.status === "available")
      );
      setInitialLoading(false);
    } catch (error) {
      console.error("Error fetching cars:", error);
      setInitialLoading(false);
    }
  };

  const fetchCarDetails = async (carId) => {
    try {
      setLoading(true);
      const response = await cars.getById(carId);
      setSelectedCarDetails(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching car details:", error);
      setLoading(false);
    }
  };

  const handleCarSelect = (car) => {
    setSelectedCar(car);
    fetchCarDetails(car._id);
    fetchInitialPricing(car.category, car.stringId);
  };

  const fetchInitialPricing = async (category, stringId) => {
    try {
      const today = new Date();
      const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      const response = await cars.getAvailable({
        startDate: monthStart.toISOString(),
        endDate: monthEnd.toISOString(),
        category: category,
                includeAll: true, // Include all cars in the category
      });

      setAvailabilityData({
        dynamicPrices:
          response.data.find((c) => c.stringId === stringId)?.availability ||
          [],
      });
    } catch (error) {
      console.error("Error fetching initial pricing:", error);
    }
  };

  const handleMonthChange = async (date) => {
    if (!selectedCar) return;

    try {
      const monthStart = new Date(date.getFullYear(), date.getMonth(), 1);
      const monthEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      const response = await cars.getAvailable({
        startDate: monthStart.toISOString(),
        endDate: monthEnd.toISOString(),
        category: selectedCar.category,
                includeAll: true, // Include all cars in the category

      });

      setAvailabilityData({
        dynamicPrices:
          response.data.find((c) => c.stringId === selectedCar.stringId)
            ?.availability || [],
      });
    } catch (error) {
      console.error("Error fetching pricing for month:", error);
    }
  };

  const validateDates = (newDate, type) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (type === "pickupDate") {
      if (formData.dropoffDate && newDate > formData.dropoffDate) {
        setErrors((prev) => ({
          ...prev,
          pickupDate: "Pick-up date cannot be after drop-off date",
        }));
        return false;
      }
    } else if (type === "dropoffDate") {
      if (formData.pickupDate && newDate < formData.pickupDate) {
        setErrors((prev) => ({
          ...prev,
          dropoffDate: "Drop-off date cannot be before pick-up date",
        }));
        return false;
      }
    }

    setErrors((prev) => ({ ...prev, [type]: undefined }));
    return true;
  };

  const handleDateChange = (date, type) => {
    if (!validateDates(date, type)) {
      return;
    }

    const isPickup = type === "pickupDate";
    const stateKey = isPickup ? "pickup" : "dropoff";

    // Check if both date and time are selected
    const hasTime = date && date.getHours() !== 0;

    setDateTimeComplete((prev) => ({
      ...prev,
      [stateKey]: hasTime,
    }));

    // Show warning if time is not selected
    setTimeWarnings(prev => ({
      ...prev,
      [stateKey]: !hasTime
    }));

    setFormData((prev) => ({
      ...prev,
      [type]: date,
    }));

    // Only close if time is selected
    if (hasTime) {
      setDatePickerOpen((prev) => ({
        ...prev,
        [stateKey]: false,
        // If pickup date is set, open dropoff picker
        ...(isPickup ? { dropoff: true } : {}),
      }));
    }
  };

  const calculatePriceBreakdown = () => {
    if (!formData.pickupDate || !formData.dropoffDate || !selectedCar) {
      return null;
    }

    const breakdown = [];
    // Use the exact pickup time
    let currentDate = new Date(formData.pickupDate);
    // Clone end date to avoid modifying the original state date
    const endDate = new Date(formData.dropoffDate);

    // Use custom price if it's set and valid
    const customPriceStr = formData.customPricePerDay;
    const customPrice = customPriceStr !== "" && customPriceStr !== null && customPriceStr !== undefined
      ? parseFloat(customPriceStr)
      : null;

    // Only consider custom price valid if it's a positive number
    const isCustomPriceValid = customPrice !== null && !isNaN(customPrice) && customPrice > 0;

    // Reset time components to midnight for date-based comparisons, but keep original times for calculations
    const exactPickupDate = new Date(currentDate);
    const exactDropoffDate = new Date(endDate);
    
    let loopCurrentDate = new Date(currentDate);
    loopCurrentDate.setHours(0, 0, 0, 0);
    
    const loopEndDate = new Date(endDate);
    loopEndDate.setHours(23, 59, 59, 999); // End of day for comparison

    while (loopCurrentDate <= loopEndDate) {
      const dateString = loopCurrentDate.toDateString();

      // Get dynamic price if available and no valid custom price is set
      const dynamicPriceData = !isCustomPriceValid
        ? availabilityData?.dynamicPrices?.find(
            (p) => new Date(p.date).toDateString() === dateString
          )
        : null;

      // Use custom price if valid, otherwise use dynamic or base price
      const price = isCustomPriceValid
        ? customPrice
        : dynamicPriceData?.dynamicPrice || selectedCar.basePrice;

      // Try to merge with previous entry if same price
      const lastEntry = breakdown.length > 0 ? breakdown[breakdown.length - 1] : null;
      if (lastEntry && lastEntry.price === price && lastEntry.endDate.toDateString() === new Date(loopCurrentDate.getTime() - 86400000).toDateString()) {
        // Check if the current day is consecutive to the last day in the period
        lastEntry.days++;
        lastEntry.endDate = new Date(loopCurrentDate);
      } else {
        breakdown.push({
          startDate: new Date(loopCurrentDate),
          endDate: new Date(loopCurrentDate),
          price,
          days: 1,
        });
      }

      // Move to the next day
      loopCurrentDate = new Date(loopCurrentDate.setDate(loopCurrentDate.getDate() + 1));
    }

    // Adjust days for the last period based on actual dropoff time
    // This ensures we don't charge for a full day if the rental ends early in the day
    if (breakdown.length > 0) {
      const lastPeriod = breakdown[breakdown.length - 1];
      const lastDayStart = new Date(lastPeriod.endDate);
      lastDayStart.setHours(0, 0, 0, 0);
      
      // If dropoff is on the same day as the last day in our breakdown
      if (lastDayStart.toDateString() === endDate.toDateString()) {
        // Compare with the original pickup time to determine if it's a full day
        const pickupTime = exactPickupDate.getHours() * 60 + exactPickupDate.getMinutes();
        const dropoffTime = exactDropoffDate.getHours() * 60 + exactDropoffDate.getMinutes();
        
        // If times are exactly equal or dropoff time is earlier than pickup time
        if (dropoffTime < pickupTime || dropoffTime === pickupTime) {
          // If this period has only one day and we need to remove it
          if (lastPeriod.days === 1) {
            breakdown.pop(); // Remove the last period entirely
          } else {
            lastPeriod.days--; // Reduce days by 1
            // Adjust the end date to the day before
            const newEndDate = new Date(lastPeriod.endDate);
            newEndDate.setDate(newEndDate.getDate() - 1);
            lastPeriod.endDate = newEndDate;
          }
        }
      }
    }

    return breakdown;
  };

  const calculateTotalPrice = useCallback(() => {
    if (!formData.pickupDate || !formData.dropoffDate || !selectedCar) {
      return 0;
    }

    const breakdown = calculatePriceBreakdown(); // Uses the latest formData via calculatePriceBreakdown
    if (!breakdown || breakdown.length === 0) {
        // Handle case where breakdown might be null or empty, maybe return base price for 1 day?
        // Or return 0 if dates aren't valid enough for a breakdown
         return 0;
    }

    const subtotal = breakdown.reduce(
      (total, period) => total + period.price * period.days,
      0
    );

    // Calculate duration accurately using the new function
    const totalDays = calculateDurationIn24HourDays(formData.pickupDate, formData.dropoffDate);

    // Apply duration-based discounts using server configuration
    let discountPercentage = 0;
    if (totalDays > 10 && durationDiscounts.longTerm?.discount) {
      discountPercentage = durationDiscounts.longTerm.discount;
    } else if (totalDays > 3 && durationDiscounts.mediumTerm?.discount) {
      discountPercentage = durationDiscounts.mediumTerm.discount;
    } else if (durationDiscounts.shortTerm?.discount) { // Check if shortTerm exists
      discountPercentage = durationDiscounts.shortTerm.discount;
    }    const durationDiscountAmount = (subtotal * discountPercentage) / 100;
    
    // Calculate the cost of additional options
    let additionalOptionsCost = 0;
    if (additionalOptionsData.length > 0 && formData.additionalOptions) {
      additionalOptionsData.forEach(option => {
        if (formData.additionalOptions[option._id]) {
          additionalOptionsCost += option.price * totalDays;
        }
      });
    }

    // Return the total price *before* coupon and VAT, but including additional options
    return subtotal - durationDiscountAmount + additionalOptionsCost;  }, [
    // Dependencies: Recalculates when these change
    formData.pickupDate,
    formData.dropoffDate,
    formData.customPricePerDay, // Explicit dependency
    formData.additionalOptions, // Additional options should trigger recalculation
    selectedCar,
    availabilityData,
    durationDiscounts,
    additionalOptionsData, // Include the available options data
    // calculatePriceBreakdown is implicitly covered by formData dependencies
  ]);

  useEffect(() => {
    if (formData.pickupDate && formData.dropoffDate && selectedCar) {
      // Calculate base price using the updated calculateTotalPrice
      const basePrice = calculateTotalPrice();

      // Calculate net total before VAT
      const netTotal = basePrice / 1.24;

      // Apply coupon discount if valid
      const netAfterDiscount =
        netTotal - (couponStatus.isValid ? couponStatus.discount : 0);

      // Apply VAT to get the final total
      const finalTotal = netAfterDiscount * 1.24;

      // Set the final total price state
      setTotalPrice(finalTotal);
    } else {
      // Reset price if dates or car are missing
      setTotalPrice(0);
    }
  }, [
    // Dependencies: Recalculates when any of these change
    formData.pickupDate,
    formData.dropoffDate,
    formData.customPricePerDay, // Explicitly listen for custom price changes
    selectedCar,
    calculateTotalPrice, // The memoized calculation function
    couponStatus.isValid, // Listen for coupon validity changes
    couponStatus.discount, // Listen for coupon discount amount changes
  ]);

  // --- validateCoupon (Unchanged) ---
  const validateCoupon = async (code) => {
    if (!code) {
      setCouponStatus({ isValid: false, discount: 0, message: "" });
      return;
    }

    try {
      const basePrice = calculateTotalPrice(); // Use the calculation function
      const netTotal = basePrice / 1.24; // Calculate net amount for validation

      // Validate coupon against the net price (excluding VAT)
      const response = await coupons.validate(code, netTotal);
      setCouponStatus({
        isValid: true,
        discount: response.data.discount, // Store the discount amount
        message: "✓ Coupon applied successfully!",
      });
    } catch (error) {
      setCouponStatus({
        isValid: false,
        discount: 0,
        message: "✕ Invalid coupon code",
      });
    }
  };


  const validateForm = () => {
    const newErrors = {};

    if (!selectedCar) newErrors.car = "Please select a car";
    if (!formData.pickupDate)
      newErrors.pickupDate = "Pick-up date and time are required";
    if (!formData.dropoffDate)
      newErrors.dropoffDate = "Drop-off date and time are required";
    if (!formData.firstName) newErrors.firstName = "First name is required";
    if (!formData.lastName) newErrors.lastName = "Last name is required";
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email address";
    }
    if (!formData.phone) newErrors.phone = "Phone number is required";
    if (!formData.pickupLocation) {
      newErrors.pickupLocation = "Pick-up location is required";
    } else if (
      formData.pickupLocation === "other" &&
      !formData.customPickupLocation
    ) {
      newErrors.pickupLocation = "Please enter the custom pick-up location";
    }

    // NEW: Advanced Payment Validation
    if (formData.advancePayment) {
      const advancePayment = parseFloat(formData.advancePayment);
      if (isNaN(advancePayment) || advancePayment < 0) {
        newErrors.advancePayment = "Advanced payment must be a positive number";
      } else if (advancePayment > totalPrice) {
        newErrors.advancePayment = "Advanced payment cannot exceed total price";
      }
    }

    if (!sameLocation) {
      if (!formData.dropoffLocation) {
        newErrors.dropoffLocation = "Drop-off location is required";
      } else if (
        formData.dropoffLocation === "other" &&
        !formData.customDropoffLocation
      ) {
        newErrors.dropoffLocation = "Please enter the custom drop-off location";
      }
    }

    // Ensure drop-off is strictly after pick-up
    if (formData.pickupDate && formData.dropoffDate) {
      // Add a small buffer (e.g., 1 minute) to avoid issues with exact same time
      const minDropoffTime = new Date(formData.pickupDate.getTime() + 60000);
      if (formData.dropoffDate <= minDropoffTime) {
        newErrors.dropoffDate = "Drop-off time must be after pick-up time";
      }
    }


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // --- formatDateRange (Unchanged) ---
  const formatDateRange = (date) => {
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
    });
  };
  const calculateDurationIn24HourDays = (pickupDateStr, dropoffDateStr) => {
    if (!pickupDateStr || !dropoffDateStr) {
      return 0;
    }

    const pickupDate = new Date(pickupDateStr);
    const dropoffDate = new Date(dropoffDateStr);

    // Check for invalid date strings or objects
    if (isNaN(pickupDate.getTime()) || isNaN(dropoffDate.getTime())) {
      console.error("Invalid date provided for duration calculation.");
      return 0;
    }

    if (dropoffDate <= pickupDate) {
      if (dropoffDate.getTime() === pickupDate.getTime()) {
        return 0; 
      }
      // If dropoffDate < pickupDate, it's an invalid range, return 0
      if (dropoffDate < pickupDate) {
        return 0;
      }
    }

    const diffTime = dropoffDate.getTime() - pickupDate.getTime(); // Difference in milliseconds

    if (diffTime < 0) {
      return 0;
    }

    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    
    // Get the exact time components in minutes since midnight
    const pickupMinutes = pickupDate.getHours() * 60 + pickupDate.getMinutes();
    const dropoffMinutes = dropoffDate.getHours() * 60 + dropoffDate.getMinutes();
    
    // Calculate full days between dates
    const fullDays = Math.floor(diffTime / millisecondsPerDay);
    
    // Only add an extra day if the dropoff time is STRICTLY later than the pickup time
    // This ensures that exact same times don't add an extra day
    let extraDay = 0;
    
    // Handle exact same times edge case
    if (dropoffMinutes > pickupMinutes) {
      extraDay = 1;
    } else if (dropoffMinutes === pickupMinutes) {
      // If minutes are the same, check seconds for absolute precision
      const pickupSeconds = pickupDate.getSeconds();
      const dropoffSeconds = dropoffDate.getSeconds();
      if (dropoffSeconds > pickupSeconds) {
        extraDay = 1;
      }
    }
    
    return fullDays + extraDay;
  };

  // --- renderDayContents (Unchanged) ---
  const renderDayContents = (day, date) => {
    if (!selectedCar) return day;

    const dayDate = new Date(date);

    // Find dynamic price for this date if available
    const dynamicPriceData = availabilityData?.dynamicPrices?.find(
      (p) => new Date(p.date).toDateString() === dayDate.toDateString()
    );

    const dayPrice = dynamicPriceData?.dynamicPrice || selectedCar.basePrice;

    return (
      <div className="relative py-4 mx-auto text-center">
        <span>{dayDate.getDate()}</span>
        {dayPrice && (
          <div
            className={`absolute bottom-0 left-0 right-0 text-[10px] ${
              dynamicPriceData ? "text-blue-600" : "text-green-600"
            } font-bold`}
          >
            €{dayPrice}
          </div>
        )}
      </div>
    );
  };

  const colors = {
    primary: "#D81919",
    secondary: "#990000",
    accent: "#FFEDED",
    dark: "#333333",
    light: "#FFFFFF",
    gray: "#F8F8F8",
  };



  const generateInvoice = async (rental) => {
      // Ensure rental.priceBreakdown exists and is an array
      const priceBreakdown = Array.isArray(rental.priceBreakdown) ? rental.priceBreakdown : [];

      const invoiceDiv = document.createElement("div");
      invoiceDiv.style.padding = "10px";
      invoiceDiv.style.position = "absolute";
      invoiceDiv.style.left = "-9999px";
      invoiceDiv.style.background = "white";
      invoiceDiv.style.width = "900px"; // A4-like width

      const header = `
      <div style="display: flex; justify-content: space-between; margin-bottom: 40px; position: relative;">
        <div style="width: 66%; position: relative; overflow: hidden; height: 120px;">
      <div style="position: absolute; top: -20px; left: -200px; width: calc(100% + 220px); height: calc(100% + 40px); transform: skew(-15deg); z-index: 0; box-shadow: 0 3px 10px rgba(0,0,0,0.2);"></div>
          <img src="${logo}" alt="Logo" style="width: 85%; height: 100%; object-fit: contain; position: relative; z-index: 1; padding: 20px 20px 20px 40px;" />
        </div>
        <div style="width: 32%; text-align: right; padding: 20px; background: ${colors.gray}; border-right: 5px solid ${colors.primary}; box-shadow: 0 3px 8px rgba(0,0,0,0.1);">
          <h2 style="margin-bottom: 15px; color: ${colors.primary}; font-size: 22px; font-weight: bold;">Contact Information</h2>
          <p style="margin: 5px 0; color: ${colors.dark};">Epar. Odos Mykonos 846 00</p>
          <p style="margin: 5px 0; color: ${colors.dark};">nleont@gmail.com</p>
          <p style="margin: 5px 0; color: ${colors.dark}; font-weight: bold;">+306941419012</p>
          <p style="margin: 5px 0; color: ${colors.primary};">${window.location.origin}</p>
        </div>
      </div>
      <div style="text-align: center; margin-bottom: 30px; padding: 10px 0; border-bottom: 2px solid ${colors.primary}; border-top: 2px solid ${colors.primary};">
        <h1 style="margin: 0; color: ${colors.primary}; font-size: 28px; text-transform: uppercase; letter-spacing: 2px;">PRE-INVOICE</h1>
        <p style="margin: 5px 0; color: ${colors.dark};">Pre-Invoice #: INV-${new Date().getFullYear()}-${Math.floor(Math.random() * 1000000)}</p>
        <p style="margin: 5px 0; color: ${colors.dark};">Pre-Invoice Date: ${new Date().toLocaleDateString("en-GB")}</p>
      </div>
        `;

      const infoSection = `
      <div style="display: flex; justify-content: space-between; margin-bottom: 40px; gap: 40px;">
        <div style="flex: 1; background: ${colors.accent}; padding: 25px; border-radius: 8px; border-left: 6px solid ${colors.primary}; box-shadow: 0 3px 10px rgba(0,0,0,0.1);">
          <h3 style="margin-bottom: 15px; color: ${colors.primary}; text-transform: uppercase; font-weight: bold; border-bottom: 2px solid ${colors.primary}; padding-bottom: 8px;">CLIENT DETAILS</h3>
          <p style="margin: 10px 0; font-weight: bold; font-size: 16px;">${rental.customer.firstName} ${rental.customer.lastName}</p>
          <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Phone:</span> ${rental.customer.phoneNumber}</p>
          <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Email:</span> ${rental.customer.email}</p>
          <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Age:</span> ${rental.customer.age}</p>
        </div>
        <div style="flex: 1; background: ${colors.accent}; padding: 25px; border-radius: 8px; border-left: 6px solid ${colors.primary}; box-shadow: 0 3px 10px rgba(0,0,0,0.1);">
          <h3 style="margin-bottom: 15px; color: ${colors.primary}; text-transform: uppercase; font-weight: bold; border-bottom: 2px solid ${colors.primary}; padding-bottom: 8px;">VEHICLE INFORMATION</h3>
          <p style="margin: 10px 0; font-weight: bold; font-size: 16px;"><span style="color: ${colors.secondary}; font-weight: bold;">Vehicle Name:</span> ${rental.carName}</p>
          <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Rental Period:</span> ${new Date(rental.pickupDateTime).toLocaleDateString("en-GB", { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })} - ${new Date(rental.returnDateTime).toLocaleDateString("en-GB", { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
          <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Pick-up:</span> ${rental.pickupLocation}</p>
          <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Return:</span> ${rental.returnLocation}</p>
        </div>
      </div>
    `;

      const priceRows = priceBreakdown.map((period, index) => `
      <tr style="background-color: ${index % 2 === 0 ? colors.light : colors.accent};">
        <td style="padding: 14px; border-bottom: 1px solid #ddd; font-weight: bold;">
          Rental (${new Date(period.startDate).toLocaleDateString("en-GB")} - ${new Date(period.endDate).toLocaleDateString("en-GB")})
        </td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">€${period.pricePerDay?.toFixed(2) ?? 'N/A'}</td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">${period.numberOfDays ?? 'N/A'}</td>
        <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: right; font-weight: bold;">€${period.totalForPeriod?.toFixed(2) ?? 'N/A'}</td>
      </tr>
    `).join("");      const additionalOptionsRows = [];
      if (rental.additionalOptions && Array.isArray(rental.additionalOptions) && rental.totalRentalDays !== undefined) {
        const totalDaysForInvoice = rental.totalRentalDays;
        rental.additionalOptions.forEach(option => {
          const priceText = option.price > 0 ? `€${option.price.toFixed(2)}` : "Free";
          const totalText = option.price > 0 ? `€${(option.price * totalDaysForInvoice).toFixed(2)}` : "€0.00";
          additionalOptionsRows.push(
            `<tr style="background-color: ${colors.accent};">
               <td style="padding: 15px; text-align: left; border: 1px solid #eee;">${option.name} (Additional Option)</td>
               <td style="padding: 15px; text-align: center; border: 1px solid #eee;">${priceText}</td>
               <td style="padding: 15px; text-align: center; border: 1px solid #eee;">${totalDaysForInvoice}</td>
               <td style="padding: 15px; text-align: right; border: 1px solid #eee; font-weight: ${option.price > 0 ? 'bold' : 'normal'};">${totalText}</td>
             </tr>`
          );
        });
      }

      const priceTable = `
      <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px; border: 2px solid ${colors.primary}; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
        <thead>
          <tr style="background: ${colors.primary}; color: white;">
            <th style="padding: 15px; text-align: left; font-size: 15px;">Description</th>
            <th style="padding: 15px; text-align: center; font-size: 15px;">Rate</th>
            <th style="padding: 15px; text-align: center; font-size: 15px;">Quantity</th>
            <th style="padding: 15px; text-align: right; font-size: 15px;">Amount</th>
          </tr>
        </thead>
        <tbody>
          ${priceRows}
          ${additionalOptionsRows.join("")}
        </tbody>
      </table>
    `;

      const additionalNotesSection = rental.additionalNotes
        ? `
        <div style="margin-bottom: 20px; background: #f8f8f8; padding: 15px; border-left: 4px solid ${colors.primary}; border-radius: 4px;">
          <h4 style="margin-bottom: 10px; color: ${colors.primary}; text-transform: uppercase; font-weight: bold;">Additional Notes</h4>
          <p style="margin: 0; font-style: italic;">${rental.additionalNotes}</p>
        </div>
      `
        : "";

      // Calculate amounts for totals section
      const calculatedSubtotal = rental.totalPrice / 1.24 + (rental.discountAmount || 0);
      const calculatedVat = rental.totalPrice - (rental.totalPrice / 1.24);


      const totalsSection = `
      <div style="display: flex; justify-content: flex-end;">
        <div style="width: 350px;">
          <div style="border: 2px solid ${colors.primary}; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
            <div style="padding: 14px; border-bottom: 1px solid #ddd; background: ${colors.accent};">
              <div style="display: flex; justify-content: space-between;">
                <span style="font-weight: bold;">Subtotal:</span>
                <span>€${calculatedSubtotal.toFixed(2)}</span>
              </div>
            </div>
            ${rental.discountAmount ? `
            <div style="padding: 14px; border-bottom: 1px solid #ddd; background: ${colors.accent}; color: ${colors.primary};">
              <div style="display: flex; justify-content: space-between;">
                <span style="font-weight: bold;">Discount:</span>
                <span>-€${rental.discountAmount.toFixed(2)}</span>
              </div>
            </div>
            ` : ""}
            <div style="padding: 14px; border-bottom: 1px solid #ddd; background: ${colors.accent};">
              <div style="display: flex; justify-content: space-between;">
                <span style="font-weight: bold;">VAT (24%):</span>
                <span>€${calculatedVat.toFixed(2)}</span>
              </div>
            </div>
            <div style="padding: 16px; background: ${colors.primary}; color: white;">
              <div style="display: flex; justify-content: space-between; font-weight: bold; font-size: 18px;">
                <span>TOTAL:</span>
                <span>€${rental.totalPrice.toFixed(2)} (NOT PAID)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
      const footer = `
      <div style="margin-top: 50px;">
        <div style="margin-bottom: 30px; padding: 20px; background: ${colors.accent}; border-radius: 8px; border-left: 6px solid ${colors.primary}; box-shadow: 0 3px 10px rgba(0,0,0,0.1);">
          <p style="margin: 0; font-style: italic; color: ${colors.dark};">Thank you for choosing <span style="font-weight: bold; color: ${colors.primary};">Luxury Car Mykonos Rental</span>. For assistance, contact us at <span style="font-weight: bold;">+306941419012</span> or <span style="font-weight: bold;">nleont@gmail.com</span></p>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 30px;">
          <div style="width: 30%;">
            <div style="background: ${colors.primary}; height: 4px; margin-bottom: 5px;"></div>
            <div style="background: ${colors.primary}; height: 2px;"></div>
          </div>
          <div style="width: 200px; text-align: center;">
            <div style="border-bottom: 2px solid ${colors.primary}; margin-bottom: 8px; padding-bottom: 15px;">
              </div>
            <p style="margin: 0; font-weight: bold; color: ${colors.primary};">Nikos Leontitsis</p>
            <p style="margin: 0; color: ${colors.dark};">Managing Director</p>
          </div>
          <div style="width: 30%;">
            <div style="background: ${colors.primary}; height: 4px; margin-bottom: 5px;"></div>
            <div style="background: ${colors.primary}; height: 2px;"></div>
          </div>
        </div>
      </div>
      <div style="margin-top: 40px; text-align: center; padding-top: 20px; border-top: 2px dashed ${colors.accent};">
      </div>
    `;

      invoiceDiv.innerHTML =
        header +
        infoSection +
        priceTable +
        additionalNotesSection +
        totalsSection +
        footer;
      document.body.appendChild(invoiceDiv);

      try {
        const scale = 2;
        const canvas = await html2canvas(invoiceDiv, {
          scale: scale,
          logging: false,
          useCORS: true,
          allowTaint: true,
        });

        const imgData = canvas.toDataURL("image/jpeg", 1.0);
        const pdf = new jsPDF("p", "pt", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width / scale;
        const imgHeight = canvas.height / scale;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const imgX = (pdfWidth - imgWidth * ratio) / 2;
        const imgY = 20; // Top margin

        pdf.addImage(
          imgData,
          "JPEG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        );

        // Add page numbers (if needed, currently single page)
        const pageCount = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(150);
        }

        const pdfData = pdf.output("datauristring");
        return pdfData.split(",")[1]; // Return base64 data
      } finally {
        document.body.removeChild(invoiceDiv);
      }
    };




  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      // Build rental data
      const effectivePickupLocation =
        formData.pickupLocation === "other"
          ? formData.customPickupLocation
          : locationOptions.find(opt => opt.value === formData.pickupLocation)?.label || formData.pickupLocation; // Use label for predefined
      const effectiveDropoffLocation = sameLocation
        ? effectivePickupLocation // Use the already determined effective pickup location
        : formData.dropoffLocation === "other"
        ? formData.customDropoffLocation
        : locationOptions.find(opt => opt.value === formData.dropoffLocation)?.label || formData.dropoffLocation; // Use label for predefined


      // Final price is already calculated and stored in totalPrice state
      const finalTotal = totalPrice;

      // Calculate net total and discount amount based on the final price
      const netTotalWithVat = finalTotal;
      const netTotalBeforeVat = netTotalWithVat / 1.24;
      const basePriceBeforeDiscount = calculateTotalPrice(); // Get base price before coupon
      const netBasePriceBeforeDiscount = basePriceBeforeDiscount / 1.24;
      const discountAmount = couponStatus.isValid ? couponStatus.discount : 0;
      // Ensure discount doesn't make price negative
      const actualDiscountApplied = Math.min(discountAmount, netBasePriceBeforeDiscount);
      const netAfterDiscount = netBasePriceBeforeDiscount - actualDiscountApplied;


      // Format price breakdown using the function
      const priceBreakdownForPayload = calculatePriceBreakdown()?.map((period) => ({
        startDate: period.startDate.toISOString(),
        endDate: period.endDate.toISOString(),
        pricePerDay: period.price,
        numberOfDays: period.days,
        totalForPeriod: period.price * period.days,
      }));

      // Calculate commission amount based on partner's rate and net price *after* discount
      const commissionRate = partner?.commissionRate || 0;
      const commissionAmount = (netAfterDiscount * commissionRate) / 100;

      // Check if a valid custom price was set
      const customPriceStr = formData.customPricePerDay;
       const customPrice = customPriceStr !== "" && customPriceStr !== null && customPriceStr !== undefined
          ? parseFloat(customPriceStr)
          : null;
      const isCustomPriceValid = customPrice !== null && !isNaN(customPrice) && customPrice > 0;

      // NEW: Check for advanced payment
      const advancePaymentStr = formData.advancePayment;
      const advancePayment = advancePaymentStr ? parseFloat(advancePaymentStr) : 0;
      const hasadvancePayment = advancePayment > 0 && !isNaN(advancePayment);

      const rentalDataForApi = {
        car: selectedCar.stringId,
        carName: `${selectedCar.make} ${selectedCar.model}`,
        customer: {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          phoneNumber: formData.phone,
          age: formData.age,
        },
        pickupLocation: effectivePickupLocation,
        returnLocation: effectiveDropoffLocation,        pickupDateTime: new Date(formData.pickupDate).toISOString(),
        returnDateTime: new Date(formData.dropoffDate).toISOString(),
        // Process additional options for API submission
        additionalOptions: (() => {
          const processedOptions = [];
          if (additionalOptionsData.length > 0 && formData.additionalOptions) {
            additionalOptionsData.forEach(option => {
              if (formData.additionalOptions[option._id]) {
                processedOptions.push({
                  _id: option._id,
                  name: option.name,
                  price: option.price // Price per day
                });
              }
            });
          }
          return processedOptions;
        })(),
        // Total rental days for calculating option prices in invoice
        totalRentalDays: calculateDurationIn24HourDays(formData.pickupDate, formData.dropoffDate),
        // Include custom price if valid and user is partner/admin
        customPricePerDay: isCustomPriceValid && (partner?.isProfessionalPartner || partner?.isAdmin)
          ? customPrice
          : undefined,
        // NEW: Include advanced payment in the API payload
        advancePayment: hasadvancePayment ? advancePayment : undefined,
        couponCode: formData.couponCode && couponStatus.isValid ? formData.couponCode : undefined, // Only send valid coupon
        basePrice: selectedCar.basePrice, // Send original base price
        totalPrice: finalTotal, // Send the final calculated total price
        discountAmount: actualDiscountApplied, // Send the actual discount applied
        priceBreakdown: priceBreakdownForPayload, // Send the detailed breakdown
        additionalNotes: formData.notes,
        professionalPartnerId: partner._id, // Add partner ID
        commissionAmount: commissionAmount, // Add calculated commission amount
        status: "confirmed", // Auto-confirm rentals created by admin/partner
      };

      // Generate PDF data using the data prepared for the API
      const pdfData = await generateInvoice(rentalDataForApi);

      // Add PDF data to rental data
      rentalDataForApi.invoicePdf = pdfData;

      // Create the rental via API
      const response = await rentals.create(rentalDataForApi);
      onSuccess(response.data); // Notify parent component
      onClose(); // Close the modal
    } catch (error) {
      console.error("Error creating rental:", error);
      // Provide more specific error feedback if possible
      const errorMessage = error.response?.data?.message || "Failed to create rental. Please try again.";
      setErrors({ submit: errorMessage });
    } finally {
      setLoading(false); // Stop loading indicator
    }
  };


  const CustomInputComponent = ({
    value,
    onClick,
    placeholder,
    isError,
    icon: Icon,
  }) => (
    <div
      className={`w-full relative cursor-pointer ${
        isError ? "border-red-500" : "border-gray-300"
      }`}
    >
      <button
        type="button"
        className={`w-full flex items-center px-4 py-2 border ${
          isError ? "border-red-500 bg-red-50" : "border-gray-300"
        } rounded-md transition-all hover:border-blue-500 text-left`}
        onClick={onClick}
      >
        {Icon && <Icon className="text-gray-500 mr-2 flex-shrink-0" />}
        <span className="flex-grow">{value || placeholder}</span>
      </button>
    </div>
  );

  const CustomSelect = ({
    value,
    onChange,
    onOtherLocationChange,
    options,
    placeholder,
    showOtherInput = false,
    initialCustomValue = "",
    disabled = false,
  }) => {
    const [showOtherInputField, setShowOtherInputField] = useState(
      value === "other"
    );
    // Add local state to manage input value
    const [localInputValue, setLocalInputValue] = useState(initialCustomValue || '');

    // Update local state when prop changes
    useEffect(() => {
      setLocalInputValue(initialCustomValue || '');
    }, [initialCustomValue]);

    useEffect(() => {
      setShowOtherInputField(value === "other" && showOtherInput);
    }, [value, showOtherInput]);

    // Handle local input changes without immediate parent updates
    const handleLocalInputChange = (e) => {
      setLocalInputValue(e.target.value);
    };

    // Update parent component only when focus is lost or Enter is pressed
    const handleInputBlur = () => {
      onOtherLocationChange(localInputValue);
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        onOtherLocationChange(localInputValue);
      }
    };

    return (
      <div>
        <div className="relative">
          <select
            value={value}
            onChange={(e) => {
              onChange(e);
              setShowOtherInputField(
                e.target.value === "other" && showOtherInput
              );
            }}
            disabled={disabled}
            className={`w-full h-10 pl-3 pr-10 border border-gray-300 rounded bg-white hover:border-blue-500 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none ${
              disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : "" // Style for disabled
            }`}
          >
            <option value="">{placeholder}</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
            <svg
              className="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M19 9l-7 7-7-7"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </svg>
          </div>
        </div>
        {showOtherInputField && (
          <input
            type="text"
            placeholder="Enter location details"
            value={localInputValue}
            onChange={handleLocalInputChange}
            onBlur={handleInputBlur}
            onKeyDown={handleKeyDown}
            disabled={disabled}
            className={`w-full h-10 px-3 mt-2 border border-gray-200 rounded bg-white hover:border-blue-500 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : "" // Style for disabled
            }`}
          />
        )}
      </div>
    );
  };


  const CustomCheckbox = ({ checked, onChange, label, disabled = false }) => ( // Added disabled prop
    <label className={`flex items-center group p-2 rounded-md transition-colors ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:bg-gray-50'}`}>
      <div className="relative w-5 h-5 mr-3">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="opacity-0 absolute h-5 w-5 cursor-pointer"
        />
        <div
          className={`border-2 rounded-sm h-5 w-5 flex flex-shrink-0 justify-center items-center ${
            checked ? "bg-blue-500 border-blue-500" : "border-gray-300"
          } ${disabled ? 'bg-gray-200 border-gray-300' : 'focus-within:border-blue-500'}`}
        >
          {checked && (
            <svg
              className={`fill-current w-3 h-3 pointer-events-none ${disabled ? 'text-gray-400' : 'text-white'}`}
              viewBox="0 0 20 20"
            >
              <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
            </svg>
          )}
        </div>
      </div>
      <span className={`select-none ${disabled ? 'text-gray-500' : 'text-gray-700'}`}>{label}</span>
    </label>
  );


  const filteredCars = availableCars.filter((car) => {
    const matchesSearch =
      !searchQuery ||
      `${car.make} ${car.model}`
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
    const matchesCategory =
      !selectedCategory || car.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });




  const totalRentalDuration = calculateDurationIn24HourDays(formData.pickupDate, formData.dropoffDate);

  const priceBreakdown = calculatePriceBreakdown();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-hidden bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.3 }}
        className="bg-white rounded-xl shadow-2xl w-full max-w-6xl relative max-h-[90vh] overflow-hidden m-4"
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-900 to-blue-800 px-6 py-4 flex justify-between items-center sticky top-0 z-20">
          <div className="flex items-center space-x-3">
            <motion.div
              className="p-2 bg-blue-800/50 rounded-full"
              initial={{ rotate: 0 }}
              animate={{ rotate: 360 }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            >
              <FaCarSide className="text-white text-2xl" />
            </motion.div>
            <h2 className="text-xl font-bold text-white">
              Create Rental for {partner?.firstName}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-blue-800/50 rounded-full transition-colors text-white"
          >
            <IoClose size={24} />
          </button>
        </div>

        {/* Content */}
        {initialLoading ? (
          <div className="p-8 flex flex-col items-center justify-center h-[calc(90vh-4rem)]"> {/* Ensure height */}
            <LoadingSpinner size="lg" />
            <p className="mt-4 text-gray-500">Loading cars...</p>
          </div>
        ) : (
          <div className="overflow-y-auto max-h-[calc(90vh-4rem)]">
            <div className="p-6">
              <form onSubmit={handleSubmit} noValidate>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                  {/* Car Selection Column */}
                  <div className="lg:col-span-1">
                    <h3 className="text-lg font-semibold mb-4">Select a Car</h3>

                    {/* Search and Filter Controls */}
                    <div className="sticky top-0 bg-white z-10 space-y-3 mb-4 p-4 border border-gray-200 rounded-lg shadow-sm">
                      <input
                        type="text"
                        placeholder="Search cars (e.g., Fiat 500)"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />

                      <select
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      >
                        <option value="">All Categories</option>
                        {Array.from(
                          new Set(availableCars.map((car) => car.category))
                        )
                        .sort()
                        .map((category) => (
                          <option key={category} value={category}>
                            {category}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Car List */}
                    <div className="h-[calc(100vh-25rem)] overflow-y-auto border border-gray-200 rounded-lg"> {/* Adjusted height */}
                      <div className="divide-y divide-gray-200">
                        {filteredCars.length > 0 ? (
                           filteredCars.map((car) => (
                            <div
                              key={car._id}
                              className={`p-4 cursor-pointer hover:bg-gray-50 transition-colors ${
                                selectedCar?._id === car._id ? "bg-blue-50 border-l-4 border-blue-500" : "border-l-4 border-transparent" // Highlight selected
                              }`}
                              onClick={() => handleCarSelect(car)}
                              role="button" // Accessibility
                              tabIndex={0} // Accessibility
                              onKeyPress={(e) => e.key === 'Enter' && handleCarSelect(car)} // Accessibility
                            >
                              <div className="flex items-center space-x-4">
                                <div className="flex-shrink-0 h-14 w-14 bg-gray-100 rounded-md flex items-center justify-center overflow-hidden border border-gray-200">
                                  {car.images && car.images[0] ? (
                                    <img
                                      src={getImage(car.images[0])}
                                      alt={`${car.make} ${car.model}`}
                                      className="h-full w-full object-contain"
                                      loading="lazy" // Lazy load images
                                    />
                                  ) : (
                                    <FaCarSide className="text-gray-400 text-2xl" />
                                  )}
                                </div>
                                <div className="flex-1 min-w-0">
                                  <p className="text-sm font-medium text-gray-900 truncate">
                                    {car.make} {car.model}
                                  </p>
                                  <p className="text-sm text-gray-500">
                                    {car.year} • {car.category}
                                  </p>
                                  <div className="flex items-center mt-1">
                                    <span className="text-sm font-semibold text-blue-900">
                                      €{car.basePrice}/day
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                           <div className="p-6 text-center text-gray-500">
                             No cars found matching your criteria.
                           </div>
                        )}
                      </div>
                    </div>
                    {errors.car && (
                      <p className="mt-1 text-sm text-red-500">{errors.car}</p>
                    )}
                  </div>

                  {/* Rental Details Column */}
                  <div className="lg:col-span-2 space-y-6">
                    <h3 className="text-lg font-semibold mb-4">
                      Rental Details {selectedCar ? `for ${selectedCar.make} ${selectedCar.model}` : ''}
                    </h3>

                    {/* Conditional rendering based on car selection */}
                    {!selectedCar ? (
                       <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-md">
                         <p className="text-sm text-yellow-700">Please select a car from the list to proceed.</p>
                       </div>
                     ) : loading ? (
                      <div className="flex items-center justify-center py-8">
                        <LoadingSpinner />
                      </div>
                    ) : (
                      <>
                        {/* Date Selection */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200">
                          <h4 className="font-medium text-gray-900 mb-4">
                            Rental Period
                          </h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <label htmlFor="pickupDate" className="block text-sm font-medium text-gray-700 mb-1">
                                Pick-up Date & Time *
                              </label>
                              <DatePicker
                                id="pickupDate"
                                selected={formData.pickupDate}
                                onChange={(date) =>
                                  handleDateChange(date, "pickupDate")
                                }
                                onMonthChange={handleMonthChange}
                                customInput={
                                  <CustomInputComponent
                                    placeholder="Select Pick-up Date & Time"
                                    isError={!!errors.pickupDate}
                                    icon={FaCalendarAlt}
                                  />
                                }
                                dateFormat="dd/MM/yyyy HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={30}
                                placeholderText="Select Pick-up Date & Time"
                                open={datePickerOpen.pickup}
                                onClickOutside={() => {
                                  // Only close if a valid time is selected
                                  if (dateTimeComplete.pickup || !formData.pickupDate) {
                                      setDatePickerOpen((prev) => ({ ...prev, pickup: false }));
                                      // Reset warning if closed or time is now complete
                                      if (dateTimeComplete.pickup) setTimeWarnings(prev => ({ ...prev, pickup: false }));
                                  } else {
                                      // Keep open and show warning if date is selected but time isn't
                                      setTimeWarnings((prev) => ({ ...prev, pickup: true }));
                                  }
                                }}
                                wrapperClassName="w-full"
                                onInputClick={() =>
                                  setDatePickerOpen((prev) => ({
                                    ...prev,
                                    pickup: true,
                                  }))
                                }
                                renderDayContents={renderDayContents}
                                disabled={!selectedCar}
                                popperPlacement="bottom-start" // Better positioning
                              />
                              {errors.pickupDate && (
                                <p className="text-red-500 text-xs mt-1">
                                  {errors.pickupDate}
                                </p>
                              )}
                              {timeWarnings.pickup && !dateTimeComplete.pickup && ( // Show warning only if time is not complete
                                <p className="text-yellow-600 text-xs mt-1">
                                  Please select a time for pick-up.
                                </p>
                              )}
                            </div>
                            <div>
                              <label htmlFor="dropoffDate" className="block text-sm font-medium text-gray-700 mb-1">
                                Drop-off Date & Time *
                              </label>
                              <DatePicker
                                id="dropoffDate"
                                selected={formData.dropoffDate}
                                onChange={(date) =>
                                  handleDateChange(date, "dropoffDate")
                                }
                                onMonthChange={handleMonthChange}
                                customInput={
                                  <CustomInputComponent
                                    placeholder="Select Drop-off Date & Time"
                                    isError={!!errors.dropoffDate}
                                    icon={FaCalendarAlt}
                                  />
                                }
                                dateFormat="dd/MM/yyyy HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={30}
                                minDate={formData.pickupDate} // Min dropoff is pickup date
                                // Filter times to be after pickup time on the same day
                                filterTime={(time) => {
                                    if (!formData.pickupDate || !formData.dropoffDate) return true; // Allow if dates not set
                                    const pickupD = new Date(formData.pickupDate);
                                    const dropoffD = new Date(formData.dropoffDate);
                                    // If dropoff is on the same day as pickup, filter times
                                    if (dropoffD.toDateString() === pickupD.toDateString()) {
                                        return time.getTime() > pickupD.getTime();
                                    }
                                    return true; // Allow all times on subsequent days
                                }}
                                placeholderText="Select Drop-off Date & Time"
                                open={datePickerOpen.dropoff}
                                onClickOutside={() => {
                                    if (dateTimeComplete.dropoff || !formData.dropoffDate) {
                                        setDatePickerOpen((prev) => ({ ...prev, dropoff: false }));
                                        if (dateTimeComplete.dropoff) setTimeWarnings(prev => ({ ...prev, dropoff: false }));
                                    } else {
                                        setTimeWarnings((prev) => ({ ...prev, dropoff: true }));
                                    }
                                }}
                                wrapperClassName="w-full"
                                onInputClick={() =>
                                  setDatePickerOpen((prev) => ({
                                    ...prev,
                                    dropoff: true,
                                  }))
                                }
                                renderDayContents={renderDayContents}
                                disabled={!selectedCar || !formData.pickupDate} // Disable until pickup is set
                                popperPlacement="bottom-start"
                              />
                              {errors.dropoffDate && (
                                <p className="text-red-500 text-xs mt-1">
                                  {errors.dropoffDate}
                                </p>
                              )}
                              {timeWarnings.dropoff && !dateTimeComplete.dropoff && ( // Show warning only if time is not complete
                                <p className="text-yellow-600 text-xs mt-1">
                                  Please select a time for drop-off.
                                </p>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Locations */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200">
                          <h4 className="font-medium text-gray-900 mb-4 flex items-center">
                             <FaMapMarkerAlt className="mr-2 text-gray-600"/> Locations
                          </h4>
                          <div className="flex justify-end mb-2">
                            <label className="flex items-center text-xs sm:text-sm text-gray-600 cursor-pointer">
                              <input
                                type="checkbox"
                                checked={sameLocation}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  setSameLocation(isChecked);
                                  if (isChecked) {
                                    // When checked, copy pickup to dropoff
                                    setFormData((prev) => ({
                                      ...prev,
                                      dropoffLocation: prev.pickupLocation,
                                      customDropoffLocation:
                                        prev.customPickupLocation,
                                    }));
                                     // Clear potential dropoff error if locations become same
                                     setErrors(prev => ({...prev, dropoffLocation: undefined}));
                                  } else {
                                    // Optionally clear dropoff when unchecked, or leave as is
                                     setFormData((prev) => ({
                                        ...prev,
                                        dropoffLocation: "", // Or keep previous value? Decide UX.
                                        customDropoffLocation: "",
                                     }));
                                  }
                                }}
                                className="mr-1.5 sm:mr-2 w-3 h-3 sm:w-4 sm:h-4 rounded text-blue-600 focus:ring-blue-500"
                                disabled={!selectedCar}
                              />
                              <span className="whitespace-nowrap">
                                Same return location
                              </span>
                            </label>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <label htmlFor="pickupLocation" className="block text-sm font-medium text-gray-700 mb-1">
                                Pick-up Location *
                              </label>
                              <CustomSelect
                                id="pickupLocation" // Added id for label
                                value={formData.pickupLocation}
                                onChange={(e) => {
                                  const newValue = e.target.value;
                                  setFormData((prev) => ({
                                    ...prev,
                                    pickupLocation: newValue,
                                    // Clear custom field if not 'other'
                                    customPickupLocation:
                                      newValue !== "other"
                                        ? ""
                                        : prev.customPickupLocation,
                                    // Update dropoff if 'sameLocation' is checked
                                    ...(sameLocation
                                      ? {
                                          dropoffLocation: newValue,
                                          customDropoffLocation:
                                            newValue !== "other"
                                              ? ""
                                              : prev.customPickupLocation, // Use updated custom pickup
                                        }
                                      : {}),
                                  }));
                                }}
                                onOtherLocationChange={(value) => {
                                  setFormData((prev) => ({
                                    ...prev,
                                    customPickupLocation: value,
                                    // Update dropoff if 'sameLocation' is checked
                                    ...(sameLocation

                                      ? { customDropoffLocation: value }
                                      : {}),
                                  }));
                                }}
                                options={locationOptions}
                                placeholder="Select pick-up location"
                                showOtherInput={true}
                                initialCustomValue={
                                  formData.customPickupLocation
                                }
                                disabled={!selectedCar}
                              />
                              {errors.pickupLocation && (
                                <p className="text-red-500 text-xs mt-1">
                                  {errors.pickupLocation}
                                </p>
                              )}
                            </div>

                            {/* Conditionally render Drop-off Location */}
                            <div className={`${sameLocation ? 'hidden' : 'block'}`}>
                                <label htmlFor="dropoffLocation" className="block text-sm font-medium text-gray-700 mb-1">
                                  Drop-off Location *
                                </label>
                                <CustomSelect
                                  id="dropoffLocation" // Added id for label
                                  value={formData.dropoffLocation}
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    setFormData((prev) => ({
                                      ...prev,
                                      dropoffLocation: newValue,
                                      // Clear custom field if not 'other'
                                      customDropoffLocation:
                                        newValue !== "other"
                                          ? ""
                                          : prev.customDropoffLocation,
                                    }));
                                  }}
                                  onOtherLocationChange={(value) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      customDropoffLocation: value,
                                    }));
                                  }}
                                  options={locationOptions}
                                  placeholder="Select drop-off location"
                                  showOtherInput={true}
                                  initialCustomValue={
                                    formData.customDropoffLocation
                                  }
                                  disabled={!selectedCar || sameLocation} // Disable if sameLocation or no car
                                />
                                {errors.dropoffLocation && !sameLocation && ( // Only show error if different location is selected
                                  <p className="text-red-500 text-xs mt-1">
                                    {errors.dropoffLocation}
                                  </p>
                                )}
                              </div>
                          </div>
                        </div>


                        {/* Customer Information */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200">
                          <h4 className="font-medium text-gray-900 mb-4 flex items-center">
                             <FaUser className="mr-2 text-gray-600"/> Customer Information
                          </h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
                                First Name *
                              </label>
                              <input
                                id="firstName"
                                type="text"
                                placeholder="Enter first name"
                                value={formData.firstName}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    firstName: e.target.value,
                                  })
                                }
                                disabled={!selectedCar}
                                required // HTML5 validation
                                className={`w-full px-4 py-2 border ${
                                  errors.firstName
                                    ? "border-red-500 focus:ring-red-500 focus:border-red-500" // Focus style for error
                                    : "border-gray-300 focus:ring-blue-500 focus:border-blue-500" // Standard focus
                                } rounded-md transition-all hover:border-blue-500 ${
                                  !selectedCar
                                    ? "bg-gray-100 cursor-not-allowed"
                                    : ""
                                }`}
                              />
                              {errors.firstName && (
                                <p className="text-red-500 text-xs mt-1">
                                  {errors.firstName}
                                </p>
                              )}
                            </div>
                            <div>
                              <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
                                Last Name *
                              </label>
                              <input
                                id="lastName"
                                type="text"
                                placeholder="Enter last name"
                                value={formData.lastName}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    lastName: e.target.value,
                                  })
                                }
                                disabled={!selectedCar}
                                required
                                className={`w-full px-4 py-2 border ${
                                  errors.lastName
                                    ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                                    : "border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                } rounded-md transition-all hover:border-blue-500 ${
                                  !selectedCar
                                    ? "bg-gray-100 cursor-not-allowed"
                                    : ""
                                }`}
                              />
                              {errors.lastName && (
                                <p className="text-red-500 text-xs mt-1">
                                  {errors.lastName}
                                </p>
                              )}
                            </div>
                            <div>
                              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                Email Address *
                              </label>
                              <input
                                id="email"
                                type="email"
                                placeholder="Enter email address"
                                value={formData.email}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    email: e.target.value,
                                  })
                                }
                                disabled={!selectedCar}
                                required
                                className={`w-full px-4 py-2 border ${
                                  errors.email
                                    ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                                    : "border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                } rounded-md transition-all hover:border-blue-500 ${
                                  !selectedCar
                                    ? "bg-gray-100 cursor-not-allowed"
                                    : ""
                                }`}
                              />
                              {errors.email && (
                                <p className="text-red-500 text-xs mt-1">
                                  {errors.email}
                                </p>
                              )}
                            </div>
                            <div>
                              <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                                Phone Number *
                              </label>
                              <div className="relative">
                                <PhoneInput
                                  international
                                  defaultCountry="GR"
                                  value={formData.phone}
                                  onChange={(value) => {
                                    setFormData({
                                      ...formData,
                                      phone: value,
                                    });
                                  }}
                                  placeholder="Phone number with country code"
                                  autoComplete="on"
                                  disabled={!selectedCar}
                                  className={`w-full border border-gray-300 p-2 ${
                                    errors.phone ? "border-red-500" : "border-gray-300"
                                  } rounded-md transition-all hover:border-blue-500 ${
                                    !selectedCar ? "bg-gray-100 cursor-not-allowed opacity-70" : ""
                                  }`}
                                />
                                {errors.phone && (
                                  <p className="text-red-500 text-xs mt-1">
                                    {errors.phone}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div>
                              <label htmlFor="age" className="block text-sm font-medium text-gray-700 mb-1">
                                Age *
                              </label>
                              <select
                                id="age"
                                value={formData.age}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    age: e.target.value,
                                  })
                                }
                                disabled={!selectedCar}
                                required
                                className={`w-full h-10 px-3 border border-gray-300 rounded bg-white appearance-none hover:border-blue-500 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                  !selectedCar
                                    ? "bg-gray-100 cursor-not-allowed opacity-70" // Style for disabled
                                    : ""
                                }`}
                              >
                                {/* Age options */}
                                {Array.from(
                                  { length: 9 }, // Ages 18 to 26
                                  (_, i) => 18 + i
                                ).map((age) => (
                                  <option key={age} value={age}>
                                    {age} years old
                                  </option>
                                ))}
                                <option value="26+">26+ years old</option>
                              </select>
                               {/* Add age restriction info if applicable */}
                               {/* {formData.age < 21 && <p className="text-yellow-600 text-xs mt-1">Note: Minimum age requirements may apply.</p>} */}
                            </div>
                          </div>
                        </div>

                        {/* Additional Options & Coupon */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200">
                          <h4 className="font-medium text-gray-900 mb-4">
                            Additional Options & Discounts
                          </h4>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>                              <p className="text-sm font-medium text-gray-700 mb-2">
                                Additional Options:
                              </p>
                              {loadingAdditionalOptions ? (
                                <div className="flex justify-center py-2">
                                  <LoadingSpinner size="sm" />
                                </div>
                              ) : (
                                <div className="space-y-2">
                                  {additionalOptionsData.length > 0 ? (
                                    additionalOptionsData.map((option) => (
                                      <div key={option._id} className="relative group">
                                        <CustomCheckbox
                                          checked={formData.additionalOptions[option._id] || false}
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              additionalOptions: {
                                                ...formData.additionalOptions,
                                                [option._id]: e.target.checked,
                                              },
                                            })
                                          }
                                          label={`${option.name}${option.price > 0 ? ` (€${option.price.toFixed(2)})` : ' (Free)'}`}
                                          disabled={!selectedCar}
                                        />
                                        {/* Tooltip for description */}
                                        {option.description && (
                                          <div className="absolute left-0 bottom-full mb-2 w-48 bg-gray-800 text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
                                            {option.description}
                                          </div>
                                        )}
                                      </div>
                                    ))
                                  ) : (
                                    <div className="text-gray-500 text-sm italic">No additional options available</div>
                                  )}
                                </div>
                              )}
                              </div>

                              {/* NEW: Advanced Payment Section */}
                              <div className="mt-4 pt-4 border-t border-gray-200">
                                <label htmlFor="advancePayment" className="block text-sm font-medium text-gray-700 mb-1">
                                  Advanced Payment (€)
                                </label>
                                <div className="relative">
                                  <input
                                    id="advancePayment"
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    placeholder="Amount already paid"
                                    value={formData.advancePayment}
                                    onChange={(e) => {
                                      // Update state and validate
                                      const value = e.target.value;
                                      setFormData(prev => ({ ...prev, advancePayment: value }));
                                      
                                      // Clear error when field is emptied
                                      if (!value) {
                                        setErrors(prev => ({ ...prev, advancePayment: undefined }));
                                      }
                                    }}
                                    onBlur={() => {
                                      // Validate on blur
                                      if (formData.advancePayment) {
                                        const advancePayment = parseFloat(formData.advancePayment);
                                        if (isNaN(advancePayment) || advancePayment < 0) {
                                          setErrors(prev => ({ ...prev, advancePayment: "Must be a positive number" }));
                                        } else if (advancePayment > totalPrice) {
                                          setErrors(prev => ({ ...prev, advancePayment: "Cannot exceed total price" }));
                                        } else {
                                          setErrors(prev => ({ ...prev, advancePayment: undefined }));
                                        }
                                      }
                                    }}
                                    disabled={!selectedCar || !formData.pickupDate || !formData.dropoffDate || totalPrice <= 0}
                                    className={`w-full px-3 py-2 border ${
                                      errors.advancePayment ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
                                    } rounded-md transition-colors ${
                                      !selectedCar || !formData.pickupDate || !formData.dropoffDate || totalPrice <= 0 ? 'bg-gray-100 cursor-not-allowed opacity-70' : ''
                                    }`}
                                  />
                                  {errors.advancePayment && (
                                    <p className="text-red-500 text-xs mt-1">{errors.advancePayment}</p>
                                  )}
                                  <p className="text-xs text-gray-500 mt-1">
                                    {totalPrice > 0 
                                      ? `Enter amount already paid (max: €${totalPrice.toFixed(2)})`
                                      : 'Select car and dates to enable'
                                    }
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div>
                              <label htmlFor="couponCode" className="block text-sm font-medium text-gray-700 mb-1">
                                Coupon Code
                              </label>
                              <div className="relative">
                                <input
                                  id="couponCode"
                                  type="text"
                                  placeholder="Enter coupon code"
                                  value={formData.couponCode}
                                  onChange={(e) => {
                                    const code = e.target.value.toUpperCase();
                                    setFormData({
                                      ...formData,
                                      couponCode: code,
                                    });
                                    // Clear status message while typing
                                    setCouponStatus(prev => ({ ...prev, message: '' }));
                                  }}
                                  onBlur={() => // Validate on blur
                                    validateCoupon(formData.couponCode)
                                  }
                                  disabled={!selectedCar || !formData.pickupDate || !formData.dropoffDate} // Disable if dates not set
                                  className={`w-full px-4 py-2 border rounded-md transition-all ${
                                    couponStatus.isValid
                                      ? "border-green-500 focus:ring-green-500 focus:border-green-500"
                                      : couponStatus.message // Only show red border if there's an error message
                                      ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                                      : "border-gray-300 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-500"
                                  } ${
                                    !selectedCar || !formData.pickupDate || !formData.dropoffDate
                                      ? "bg-gray-100 cursor-not-allowed opacity-70"
                                      : ""
                                  }`}
                                />
                                {/* Coupon Status Message */}
                                <AnimatePresence>
                                  {couponStatus.message && (
                                    <motion.div
                                      initial={{ opacity: 0, y: -5 }}
                                      animate={{ opacity: 1, y: 0 }}
                                      exit={{ opacity: 0, y: -5 }}
                                      className={`text-xs mt-1 absolute ${ // Use absolute for smooth transition
                                        couponStatus.isValid
                                          ? "text-green-600"
                                          : "text-red-600"
                                      }`}
                                    >
                                      {couponStatus.message}
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </div>
                            </div>
                          </div>

                          <div className="mt-6"> {/* Increased margin */}
                            <label htmlFor="notes" className="block text-sm font-medium text-gray-700 mb-1">
                              Additional Notes:
                            </label>
                            <textarea
                              id="notes"
                              value={formData.notes}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  notes: e.target.value,
                                })
                              }
                              rows="3"
                              disabled={!selectedCar}
                              className={`w-full p-3 border border-gray-300 rounded bg-white hover:border-blue-500 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                                !selectedCar
                                  ? "bg-gray-100 cursor-not-allowed opacity-70"
                                  : ""
                              }`}
                              placeholder="Any special requests or notes (e.g., flight number, specific delivery instructions)"
                            />
                          </div>
                        

                        {/* Price Breakdown */}
                        <div className="bg-gradient-to-br from-blue-900 to-blue-700 p-4 rounded-lg shadow-lg text-white">
                          <h4 className="font-medium text-white mb-4 flex items-center">
                            <FaMoneyBillWave className="mr-2" />
                            Price Breakdown
                          </h4>

                          {/* --- Custom Price Input Section (MODIFIED) --- */}
                          {(partner?.isProfessionalPartner || partner?.isAdmin) && (
                            <div className="mb-4 border-b border-blue-600 pb-3">
                              <div className="flex justify-between items-center mb-1">
                                <label htmlFor="customPrice" className="block text-sm text-gray-200">
                                  Custom Price Per Day (Optional)
                                </label>
                                {/* Show Clear button only if there's a value */}
                                {formData.customPricePerDay && (
                                  <button
                                    type="button"
                                    onClick={() => {
                                      // FIX: Only update state, let useEffect handle recalculation
                                      setFormData(prev => ({...prev, customPricePerDay: ""}));
                                    }}
                                    className="text-xs text-blue-300 hover:text-blue-100 underline"
                                  >
                                    Clear Custom Price
                                  </button>
                                )}
                              </div>
                              <div className="flex items-center">
                                <span className="text-white text-lg mr-2">€</span>
                                <input
                                  id="customPrice"
                                  type="number"
                                  value={formData.customPricePerDay}
                                  onChange={(e) => {
                                    // FIX: Only update state, let useEffect handle recalculation
                                    const newCustomPrice = e.target.value;
                                    setFormData(prevFormData => ({
                                      ...prevFormData,
                                      customPricePerDay: newCustomPrice,
                                    }));
                                  }}
                                  min="0" // Prevent negative numbers
                                  step="0.01" // Allow cents
                                  placeholder="Enter custom daily rate"
                                  disabled={!selectedCar || !formData.pickupDate || !formData.dropoffDate} // Disable if dates/car not set
                                  className={`w-full bg-blue-800 border border-blue-600 text-white px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 ${
                                     (!selectedCar || !formData.pickupDate || !formData.dropoffDate) ? "opacity-50 cursor-not-allowed" : ""
                                  }`}
                                />
                              </div>
                              <p className="text-xs text-blue-300 mt-1">
                                Overrides default/dynamic prices if set. Affects total before discounts & VAT.
                              </p>

                              {/* Display calculated total based on custom price for clarity */}
                              {formData.pickupDate && formData.dropoffDate && formData.customPricePerDay &&
                               parseFloat(formData.customPricePerDay) > 0 && !isNaN(parseFloat(formData.customPricePerDay)) && (
                                <div className="mt-2 bg-blue-800/50 p-2 rounded border border-blue-600/50">
                                  <div className="flex justify-between items-center text-sm">
                                    <span className="text-blue-200">Base total (custom):</span>
                                    <span className="font-semibold text-white">
                                      €{(() => {
                                        // Calculate directly using the current custom price value
                                        const diffTime = Math.abs(new Date(formData.dropoffDate) - new Date(formData.pickupDate));
                                        const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                        const customPrice = parseFloat(formData.customPricePerDay);
                                        return (customPrice * days).toFixed(2);
                                      })()}
                                    </span>
                                  </div>
                                  <div className="flex justify-between items-center text-xs text-blue-300 mt-1">
                                    <span>(Before discounts & VAT)</span>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                          {/* --- End of Custom Price Input Section --- */}

                          {/* Detailed Price Breakdown */}
                          <div className="space-y-1 text-sm">
                              {formData.pickupDate && formData.dropoffDate && selectedCar ? (
      priceBreakdown?.length > 0 ? (
        priceBreakdown.map((period, index) => (
          <div
            key={index}
            className="flex justify-between items-center mb-1" // Added mb-1 for spacing
          >
            <span className="text-gray-300 text-sm"> {/* Adjusted text size */}
              {period.days > 1
                ? `${formatDateRange(period.startDate)} - ${formatDateRange(period.endDate)}`
                : formatDateRange(period.startDate)}              
            </span>
                                        {/* Indicate if price is custom, dynamic or base */}
                                        <span className={`font-medium ${
                                            formData.customPricePerDay && parseFloat(formData.customPricePerDay) > 0 && !isNaN(parseFloat(formData.customPricePerDay))
                                            ? 'text-yellow-300' // Custom price indicator
                                            : period.price !== selectedCar.basePrice
                                            ? 'text-blue-300' // Dynamic price indicator
                                            : 'text-gray-100' // Base price indicator
                                        }`}>
                                        €{period.price.toFixed(2)}/day
                                        {formData.customPricePerDay && parseFloat(formData.customPricePerDay) > 0 && !isNaN(parseFloat(formData.customPricePerDay)) && index === 0 && <span className="text-xs ml-1">(Custom)</span>}
                                        </span>
                                    </div>
                                    ))
                                ) : (
                                    <p className="text-center text-blue-200 py-2">Calculating price...</p>
                                )
                                ) : (
                                <p className="text-center text-blue-200 py-2">Select car and dates to see price breakdown.</p>
                             )}
                          </div>                           {/* Totals Section */}
                          {formData.pickupDate && formData.dropoffDate && selectedCar && calculatePriceBreakdown()?.length > 0 && (
                            <div className="mt-4 pt-3 border-t border-blue-600 space-y-1.5">
                              {/* Duration Discount */}
                              {(() => {
                                const days = calculateDurationIn24HourDays(formData.pickupDate, formData.dropoffDate);
                                let discountPercentage = 0;
                                if (days > 10 && durationDiscounts.longTerm?.discount) {
                                  discountPercentage = durationDiscounts.longTerm.discount;
                                } else if (days > 3 && durationDiscounts.mediumTerm?.discount) {
                                  discountPercentage = durationDiscounts.mediumTerm.discount;
                                } else if (durationDiscounts.shortTerm?.discount) {
                                  discountPercentage = durationDiscounts.shortTerm.discount;
                                }

                                if (discountPercentage > 0) {
                                  const subtotalBeforeDiscounts = calculatePriceBreakdown()?.reduce(
                                    (total, period) => total + period.price * period.days, 0
                                  ) || 0;
                                  const durationDiscountAmount = (subtotalBeforeDiscounts * discountPercentage) / 100;
                                  return (
                                    <div className="flex justify-between items-center text-sm text-green-300">
                                      <span>Duration Discount ({discountPercentage}%):</span>
                                      <span>-€{durationDiscountAmount.toFixed(2)}</span>
                                    </div>
                                  );
                                }
                                return null;
                              })()}

                             {/* Subtotal Before VAT & Coupon */}
                              <div className="flex justify-between items-center text-sm text-gray-200">
                                <span>Subtotal (before VAT):</span>
                                <span>
                                  €{(totalPrice / 1.24 + (couponStatus.isValid ? couponStatus.discount : 0)).toFixed(2)}
                                </span>
                              </div>


                              {/* Coupon Discount */}
                              {couponStatus.isValid && (
                                <div className="flex justify-between items-center text-sm text-green-300">
                                  <span>Coupon Discount:</span>
                                  <span>-€{couponStatus.discount.toFixed(2)}</span>
                                </div>
                              )}

                              {/* Net Total Before VAT */}
                              <div className="flex justify-between items-center text-sm text-gray-200 font-medium">
                                <span>Net Total (before VAT):</span>
                                <span>
                                  €{(totalPrice / 1.24).toFixed(2)}
                                </span>
                              </div>


                              {/* VAT */}
                              <div className="flex justify-between items-center text-sm text-gray-200">
                                <span>VAT (24%):</span>
                                <span>
                                  €{(totalPrice - totalPrice / 1.24).toFixed(2)}
                                </span>
                              </div>

                              {/* Commission */}
                              <div className="flex justify-between items-center text-sm text-cyan-300">
                                <span>
                                  Est. Commission ({partner?.commissionRate || 0}%):
                                </span>
                                <span>
                                  €
                                  {(
                                    (totalPrice / 1.24 * (partner?.commissionRate || 0)) / 100
                                  ).toFixed(2)}
                                   {/* Indicate if based on custom price */}
                                  {formData.customPricePerDay && parseFloat(formData.customPricePerDay) > 0 && !isNaN(parseFloat(formData.customPricePerDay)) && (
                                    <span className="text-xs ml-1 text-yellow-300">(on custom net)</span>
                                  )}
                                </span>
                              </div>

                              {/* Grand Total */}
                              <div className="flex justify-between items-center font-bold text-lg mt-3 pt-3 border-t border-blue-600">
                                <span>Total:</span>
                                <span>€{totalPrice.toFixed(2)}</span>
                              </div>
                              
                              {/* NEW: Advanced Payment Display */}
                              {formData.advancePayment && parseFloat(formData.advancePayment) > 0 && (
                                <>
                                  <div className="flex justify-between items-center text-sm text-yellow-300 mt-2">
                                    <span>Advanced Payment:</span>
                                    <span>-€{parseFloat(formData.advancePayment).toFixed(2)}</span>
                                  </div>
                                  <div className="flex justify-between items-center font-bold bg-blue-800 mt-2 p-2 rounded">
                                    <span>Balance Due:</span>
                                    <span>€{Math.max(0, totalPrice - parseFloat(formData.advancePayment)).toFixed(2)}</span>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                        </div>


                        {/* Submission Error */}
                        {errors.submit && (
                          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-4" role="alert">
                            <strong className="font-bold">Error: </strong>
                            <span className="block sm:inline">{errors.submit}</span>
                          </div>
                        )}

                        {/* Submit Button */}
                        <div className="flex justify-end mt-6">
                          <button
                            type="submit"
                            disabled={loading || !selectedCar}
                            className="px-6 py-3 bg-blue-900 text-white rounded-lg hover:bg-blue-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
                          >
                            {loading ? (
                              <>
                                <LoadingSpinner
                                  size="sm"
                                  className="text-white"
                                />
                                <span>Creating Rental...</span>
                              </>
                            ) : (
                              <>
                                <FaCarSide className="mr-1"/>
                                <span>Create Rental</span>
                              </>
                            )}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Datepicker Styles */}
        <style jsx="true">{`
          /* Ensure datepicker is above other elements */
          .react-datepicker-popper {
            z-index: 60 !important; /* Higher than modal z-index (50) */
          }

          /* Highlight selected day */
          .react-datepicker__day--selected,
          .react-datepicker__day--in-selecting-range,
          .react-datepicker__day--in-range {
            background-color: #1e3a8a !important; /* Tailwind blue-900 */
            color: white !important;
            border-radius: 0.375rem; /* rounded-md */
          }
          .react-datepicker__day--selected:hover,
          .react-datepicker__day--in-selecting-range:hover,
          .react-datepicker__day--in-range:hover {
             background-color: #1e40af !important; /* Tailwind blue-800 */
          }


          /* Highlight selected time */
          .react-datepicker__time-list-item--selected {
            background-color: #1e3a8a !important; /* Tailwind blue-900 */
            color: white !important;
          }
          .react-datepicker__time-list-item--selected:hover {
             background-color: #1e40af !important; /* Tailwind blue-800 */
          }

          /* Style the day price */
           .react-datepicker__day > div > div {
              position: absolute;
              bottom: 2px; /* Adjust as needed */
              left: 0;
              right: 0;
              font-size: 9px; /* Smaller font size */
              font-weight: 600; /* Semibold */
              line-height: 1;
           }
           .react-datepicker__day {
              position: relative; /* Needed for absolute positioning of price */
              padding-bottom: 12px; /* Make space for the price */
           }
        `}</style>
      </motion.div>
    </div>
  );
};

export default CreatePartnerRentalModal;
